import { LocationInfo, ScreeningFlag, ScreeningLocationResultItem, ScreeningPolygonResult } from '..';

export class ScreeningDetailView {
    public id: string;
    public location: LocationInfo;
    public hasV1Polygon: boolean;
    public hasV2Polygon: boolean;
    public v1PolygonResult: ScreeningPolygonResult;
    public v2PolygonResult: ScreeningPolygonResult;
    public v1Screenings: Array<ScreeningLocationResultItem>;
    public v2Screenings: Array<ScreeningLocationResultItem>;
    public missingActivities: Array<MissingObject>;
    public missingPollutionCauses: Array<MissingObject>;
    public missingPollutantComponents: Array<MissingObject>;
    public totalFlags: ScreeningFlag;
    // public screeningLog: ScreeningLog;

    public constructor(init: Partial<ScreeningDetailView>) {
        Object.assign(this, init);
    }
}

export class MissingObject {
    public code: string;
    public description: string;
    public translatedCompound: string;
    public type: any;
}
